import { env } from "../../../config/env";
import { apiClient } from "../../config";

import {
  GetProjectsResponse,
  GetProjectResponse,
} from "../../interface/projects.interface";

import {
  GetProjectCategoriesResponse,
} from "../../interface/projectcategories.interface";

class ProjectsService {
  /**
   * 🎬 GET PROJECTS
   */
  async getProjects(): Promise<GetProjectsResponse> {
    const response = await apiClient.get<GetProjectsResponse>(
      env.PUBLIC_PROJECTS_URL
    );

    return response.data;
  }

  /**
   * 📄 GET PROJECT
   */
  async getProject(id: string): Promise<GetProjectResponse> {
    const response = await apiClient.get<GetProjectResponse>(
      env.PUBLIC_PROJECT_URL(id)
    );

    return response.data;
  }

  /**
   * 🧩 GET PROJECT CATEGORIES
   */
  async getProjectCategories(): Promise<GetProjectCategoriesResponse> {
    const response = await apiClient.get<GetProjectCategoriesResponse>(
      env.PUBLIC_PROJECT_CATEGORIES_URL
    );

    return response.data;
  }
}

export const publicProjectsService = new ProjectsService();